var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-container',{staticClass:"error py-5"},[_c('b-row',[_c('b-col',[_c('h1',[_vm._v("Error "+_vm._s(_vm.$route.meta.error))])])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }